<template>
   <div>
      <form-select
         label="Departamento"
         :items="departamentos"
         itemText="nombre"
         itemValue="codigo"
         v-model="selectDepartamento"
         :loading="loadingDepartamento"
         @input="getCiudades()"
      ></form-select>
      <form-select
         label="Ciudad"
         :items="ciudades"
         itemText="nombre"
         itemValue="codigo"
         v-model="selectCiudad"
         :loading="loadingCiudad"
         @input="getEntidades()"
      ></form-select>
      <form-select
         label="Entidad"
         :items="entidades"
         itemText="nombre"
         itemValue="codigo"
         v-model="selectEntidad"
         :loading="loadingEntidad"
         @input="getEspecialidades()"
      ></form-select>
      <form-select
         label="Especialidad"
         :items="especialidades"
         itemText="nombre"
         itemValue="codigo"
         v-model="selectEspecialidad"
         :loading="loadingEspecialidad"
         @input="getDespachos()"
      ></form-select>
      <form-select
         label="Despacho"
         :items="despachos"
         itemText="nombre"
         itemValue="codigo"
         :loading="loadingDespacho"
         v-model="selectDespacho"
         @input="setDespacho()"
      ></form-select>
   </div>
</template>

<script>
//config
import axios from '../config/axios'

//Components
import FormSelect from './FormSelect'

//Mixins
import vmodel from '../js/mixins/vmodel'

export default {
   components: { FormSelect },
   mixins: [vmodel],
   props: {
      esCrearNumero:{
         type: Boolean,
         default: false
      }
   },
   data() {
      return {
         numero: '',

         departamentos: [],
         ciudades: [],
         entidades: [],
         especialidades: [],
         despachos: [],

         selectDepartamento: '',
         selectCiudad: '',
         selectEntidad: '',
         selectEspecialidad: '',
         selectDespacho: '',

         loadingDepartamento: false,
         loadingCiudad: false,
         loadingEntidad: false,
         loadingEspecialidad: false,
         loadingDespacho: false
      }
   },
   methods: {
      async getDepartamentos() {
         try {
            this.loadingDepartamento = true
            let data = await axios.get('/Lista/Departamentos')
            this.departamentos = data.data
            // // // this.loadingDepartamento = false
         } catch (error) {
            console.log(error)
         } finally {
            this.loadingDepartamento = false
         }
      },
      async getCiudades() {
         try {
            this.selectNumber(this.selectDepartamento)
            if (this.numero==='')
               return
            this.changeAndClear(1)
            this.loadingCiudad = true
            // // // let data = await axios.get(
            // // //    `/Lista/Ciudades/${this.selectDepartamento.trim()}`
            // // // )
            
            let data = await axios.get(
               `/Lista/Ciudades/${this.numero}`
            )
            this.ciudades = data.data
            // // // this.loadingCiudad = false
         } catch (error) {
            console.log(error)
         } finally {
            this.loadingCiudad = false
         }
      },
      async getEntidades() {
         try {
            this.selectNumber(this.selectCiudad)
            this.changeAndClear(2)
            if (this.numero==='')
               return
            this.loadingEntidad = true
            // // // let data = await axios.get(
            // // //    `/Lista/Entidades/${this.selectCiudad.trim()}`
            // // // )
            let data = await axios.get(
               `/Lista/Entidades/${this.numero}`
            )
            this.entidades = data.data
            // // // this.loadingEntidad = false
         } catch (error) {
            console.log(error)
         } finally {
            this.loadingEntidad = false
         }
      },
      async getEspecialidades() {
         try {
            this.selectNumber(this.selectEntidad)
            this.changeAndClear(3)
            if (this.numero==='')
               return
            this.loadingEspecialidad = true
            // // // let data = await axios.get(
            // // //    `/Lista/Especialidades/${this.selectEntidad.trim()}`
            // // // )
            let data = await axios.get(
               `/Lista/Especialidades/${this.numero}`
            )
            this.especialidades = data.data
            // // // this.loadingEspecialidad = false
         } catch (error) {
            console.log(error)
         } finally {
            this.loadingEspecialidad = false
         }
      },
      async getDespachos() {
         try {
            this.selectNumber(this.selectEspecialidad)
            this.changeAndClear(4)
            if (this.numero==='')
               return

            this.loadingDespacho = true
            // // // let data = await axios.get(
            // // //    `/Lista/Despachos/${this.selectEspecialidad.trim()}`
            // // // )
            let data = await axios.get(
               `/Lista/Despachos/${this.numero}`
            )
            
            if (this.esCrearNumero){
               // Utilizar la secretaría o adicionarla
               let aux = data.data
               // // // let obj = aux.find(o => o.codigo.substring(0,5) === '11011' && o.codigo.substring(9,12)==='000');
               // // // if (obj)
               // // //    aux=[obj]
               let obj = aux.find(o => o.codigo.substring(0,5) === '11011');
               if (obj)
                  aux=[{codigo:`11011${obj.codigo.substring(5,9)}000`, nombre:'SECRETARIA'}]
               this.despachos = aux 
            } else {
               this.despachos = data.data
            }
            // // // this.loadingDespacho = false
         } catch (error) {
            console.log(error)
         } finally {
            this.loadingDespacho = false
         }
      },
      setDespacho() {
         this.selectNumber(this.selectDespacho)
      },
      selectNumber(selected) {
         this.numero = (selected || '').trim()
         this.$emit('input', this.numero)
      },
      changeAndClear(op) {
         if (op == 1) {
            this.ciudades = []
            this.changeAndClear(2)
         } else if (op == 2) {
            this.entidades = []
            this.changeAndClear(3)
         } else if (op == 3) {
            this.especialidades = []
            this.changeAndClear(4)
         } else if (op == 4) {
            this.despachos = []
         }
      }
   },
   mounted() {
      this.getDepartamentos()
   },
   created() {
      this.$bus.on('clear-generate-number', () => {
         this.selectDepartamento = ''
         this.changeAndClear(1)
      })
   }
}
</script>
